<div class="p-datepicker-buttonbar ">
    <p-button [label]="'hrCommon.today' | translate" [text]="true"
              (click)="comp?.onDateSelect($event,dateMeta)"></p-button>
    <p-button [label]="'hrCommon.maxDate' | translate" [text]="true" (click)="comp?.onDateSelect($event,dateMetaMax)"
    ></p-button>
</div>
<!--    (click)="beginDate.onDateSelect($event,dateMeta)"-->



